import React from 'react';
export function Header() {
  return <header className="w-full bg-white border-b border-gray-200 py-4 sticky top-0 z-50 shadow-sm" data-id="element-55">
      <div className="max-w-4xl mx-auto px-6 flex justify-between items-center" data-id="element-56">
        <div className="font-sans font-bold text-xl tracking-tight text-teal-800" data-id="element-57">
          Daily<span className="text-teal-600" data-id="element-58">OralReport</span>
        </div>
        <div className="text-xs font-sans text-gray-500 uppercase tracking-wider font-semibold" data-id="element-59">
          Sponsored Advertorial
        </div>
      </div>
    </header>;
}